module.exports = __webpack_public_path__ + "images/16292-EXT1-Cam01-a5d04c46a23dffaf6205c1175b803d6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_1/16292-EXT1-Cam01.jpg
// module id = 29
// module chunks = 0